import axios from 'axios';
import { ensureProtocol } from '../config/backend';

function getBase() {
  return ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token } : {};
}

export async function fetchGruposUsuario() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/grupos-usuario', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar grupos de usuário:', err);
    return [];
  }
}

export async function fetchGruposUsuarioAtivos() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/grupos-usuario/ativos', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar grupos ativos:', err);
    return [];
  }
}

export async function createGrupoUsuario(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/grupos-usuario', body, { headers: getAuthHeaders() });
}

export async function updateGrupoUsuario(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/grupos-usuario/' + id, body, { headers: getAuthHeaders() });
}

export async function deleteGrupoUsuario(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/grupos-usuario/' + id, { headers: getAuthHeaders() });
}

export async function duplicarGruposParaEmpresa(ids, empresaDestinoId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/grupos-usuario/duplicar-para-empresa', { ids, empresa_destino_id: empresaDestinoId }, { headers: getAuthHeaders() });
}
